import styled from "styled-components";

export const TopTitleFilter = styled.header`
  padding: 30px 30px 6px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  grid-area: header;

  span {
      font-size: 1.2rem;
      color: ${(props) => props.theme.colors.brand1.pure};
  }
  svg {
    height: 14px;
    width: 14px;
  }

  button {
    width: 30px;
    height: 35px;
    border: none;
    background: none;
  }

  @media (min-width: 768px) {
    display: none;
  }
`;
